;(function () {
  'use strict'

  angular
    .module('contrast.libraries')
    .factory('LibrariesTaggingModalService', [
      '$uibModal',
      '$translate',
      LibrariesTaggingModalService
    ])

  function LibrariesTaggingModalService($uibModal, $translate) {
    var service = {
      open: open
    }

    return service

    function open(request) {
      return $uibModal.open({
        templateUrl: 'views/tags/modal_tag.html',
        controller: 'ModalTagLibrariesCtrl',
        size: 'full',
        resolve: {
          request: function () {
            return request
          },
          title: function () {
            var str = $translate.instant(
              'plural_libraries_tag',
              { count: request.libraryHashes.length },
              'messageformat'
            )
            return str
          }
        }
      }).result
    }
  }
})()
